import { useEffect, useState } from "react";
import { useAuth } from "@/auth/AuthProvider";
import { getBondSubmission, type BondSubmission } from "@/lib/brokerBonds";
import { messageFor } from "@/lib/errors";

// BRK-S183 — one bond order, read for a screen that acts on it (the bid
// result screen and the won-bid screen). The PAGE owns the order in state so
// a write's response replaces it: what renders after a save is what the server
// stored, never the form's own idea of it (NN #7).

export interface BondOrderState {
  order: BondSubmission | null;
  setOrder: (order: BondSubmission) => void;
  error: string | null;
}

export function useBondOrder(id: string): BondOrderState {
  const { authedRequest } = useAuth();
  const [order, setOrder] = useState<BondSubmission | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const fresh = await getBondSubmission(authedRequest, id);
        if (!cancelled) setOrder(fresh);
      } catch (err) {
        if (!cancelled) setError(messageFor(err));
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [authedRequest, id]);

  return { order, setOrder, error };
}
